export default "__VITE_ASSET__CWp2N2XC__"